module.exports = __webpack_public_path__ + "img/af.5ce6cd72.svg";